import { render, staticRenderFns } from "./ScodeCard.vue?vue&type=template&id=3a21f494&"
import script from "./ScodeCard.vue?vue&type=script&lang=js&"
export * from "./ScodeCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports